import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserIcon, PackageIcon, HeartIcon, MapPinIcon, SettingsIcon, LogOutIcon, ChevronRightIcon, EditIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
const menuItems = [{
  icon: PackageIcon,
  label: 'My Orders',
  href: '/account/orders',
  count: 5
}, {
  icon: HeartIcon,
  label: 'Wishlist',
  href: '/wishlist',
  count: 12
}, {
  icon: MapPinIcon,
  label: 'Addresses',
  href: '/account/addresses'
}, {
  icon: SettingsIcon,
  label: 'Settings',
  href: '/account/settings'
}];
export function AccountPage() {
  const navigate = useNavigate();
  const {
    user,
    logout,
    isAuthenticated
  } = useAuth();
  const [isEditing, setIsEditing] = useState(false);
  if (!isAuthenticated) {
    navigate('/login');
    return null;
  }
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  return <div<div> className="max-w-7xl mx-auto px-4" data-id="element-960" data-mp="2o5fo0hgt3l7w">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-961" data-mp="2t14tf1fibwc4">
        My Account
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-962" data-mp="2y2ke2sdrw0tz">
        {/* Profile card */}
        <div className="lg:col-span-1" data-id="element-963" data-mp="32zart923ukc8">
          <Card padding="lg" data-id="element-964" data-mp="32y9f705fxpse">
            <div className="text-center" data-id="element-965" data-mp="25cty0dskyov8">
              <div className="w-24 h-24 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4 overflow-hidden" data-id="element-966" data-mp="25e51eci45ult">
                <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="User Avatar" className="w-full h-full object-cover p-2" data-id="element-967" data-mp="2a9bxoz91zx0p" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-968" data-mp="1mm3xgvqhfe5j">
                {user?.name}
              </h2>
              <p className="text-gray-500" data-id="element-969" data-mp="1rknfil1yg5sm">{user?.email}</p>
              <p className="text-sm text-gray-400 mt-1" data-id="element-970" data-mp="1rj2lqxngsqvt">
                Member since Jan 2024
              </p>
            </div>

            <div className="mt-6 space-y-2" data-id="element-971" data-mp="1elo60hilf7j1">
              {menuItems.map(item => <Link key={item.label} to={item.href} className="flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-972" data-mp="1ejbkjudmmf18">
                  <div className="flex items-center gap-3" data-id="element-973" data-mp="1oc8yrobl5hu1">
                    <item.icon className="w-5 h-5 text-gray-500" data-id="element-974" data-mp="10ln2sveuvo0e" />
                    <span className="font-medium text-gray-700" data-id="element-975" data-mp="10lvggpisyxcn">
                      {item.label}
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-976" data-mp="1akcajvd1fs2x">
                    {item.count && <span className="px-2 py-0.5 bg-primary-100 text-primary-600 text-xs font-medium rounded-full" data-id="element-977" data-mp="1ahgeydonxfhn">
                        {item.count}
                      </span>}
                    <ChevronRightIcon className="w-4 h-4 text-gray-400" data-id="element-978" data-mp="2m12ltswbja3e" />
                  </div>
                </Link>)}

              <button onClick={handleLogout} className="flex items-center gap-3 p-3 rounded-lg hover:bg-red-50 transition-colors w-full text-left text-red-600" data-id="element-979" data-mp="2oje3oixxd2ea">
                <LogOutIcon className="w-5 h-5" data-id="element-980" data-mp="2tk22hqseanj2" />
                <span className="font-medium" data-id="element-981" data-mp="2fizhzih1tla9">Logout</span>
              </button>
            </div>
          </Card>
        </div>

        {/* Main content */}
        <div className="lg:col-span-2 space-y-6" data-id="element-982" data-mp="2jkkyrewpejpq">
          {/* Profile details */}
          <Card padding="lg" data-id="element-983" data-mp="37afbzxkxqaai">
            <div className="flex items-center justify-between mb-6" data-id="element-984" data-mp="37c88wl5qxg5b">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-985" data-mp="3c8guoheg87lg">
                Profile Details
              </h3>
              <Button variant="ghost" size="sm" leftIcon={<EditIcon className="w-4 h-4" data-id="element-987" data-mp="32inlfn1s44kd" />} onClick={() => setIsEditing(!isEditing)} data-id="element-986" data-mp="2yfhdmaz0q5bs">
                {isEditing ? 'Cancel' : 'Edit'}
              </Button>
            </div>

            {isEditing ? <form className="space-y-4" data-id="element-988" data-mp="3uzzuygh397js">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-989" data-mp="3v116em20nw21">
                  <Input label="Full Name" defaultValue={user?.name} data-id="element-990" data-mp="27c6db2n2db8l" />
                  <Input label="Phone" defaultValue={user?.phone} data-id="element-991" data-mp="22cbn71b44pol" />
                  <Input label="Email" type="email" defaultValue={user?.email} className="md:col-span-2" data-id="element-992" data-mp="22e4vel1djhyp" />
                </div>
                <div className="flex gap-3" data-id="element-993" data-mp="1tbn7m262mh9l">
                  <Button variant="primary" type="submit" data-id="element-994" data-mp="1tcot70kpqm5k">
                    Save Changes
                  </Button>
                  <Button variant="outline" onClick={() => setIsEditing(false)} data-id="element-995" data-mp="2q0usr92s2ocz">
                    Cancel
                  </Button>
                </div>
              </form> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-996" data-mp="2garsqox8oa55">
                <div data-id="element-997" data-mp="2cahll8xpndop">
                  <p className="text-sm text-gray-500" data-id="element-998" data-mp="2cb134ojg8027">Full Name</p>
                  <p className="font-medium text-gray-900" data-id="element-999" data-mp="38s45dr7uht8s">{user?.name}</p>
                </div>
                <div data-id="element-1000" data-mp="341ffuhfq76ca">
                  <p className="text-sm text-gray-500" data-id="element-1001" data-mp="340vyb1tzmjys">Phone</p>
                  <p className="font-medium text-gray-900" data-id="element-1002" data-mp="33zks6vd2l04i">{user?.phone}</p>
                </div>
                <div className="md:col-span-2" data-id="element-1003" data-mp="ql475ywemkoe">
                  <p className="text-sm text-gray-500" data-id="element-1004" data-mp="vivxwplbc0r0">Email</p>
                  <p className="font-medium text-gray-900" data-id="element-1005" data-mp="zjfvfu9st6do">{user?.email}</p>
                </div>
              </div>}
          </Card>

          {/* Recent orders */}
          <Card padding="lg" data-id="element-1006" data-mp="14ju51gr1sodt">
            <div className="flex items-center justify-between mb-6" data-id="element-1007" data-mp="19hnag7kj1ed1">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-1008" data-mp="19hdjagnqx15r">
                Recent Orders
              </h3>
              <Link to="/account/orders" className="text-primary-600 hover:text-primary-700 text-sm font-medium" data-id="element-1009" data-mp="1eedokpcrtzvt">
                View All
              </Link>
            </div>

            <div className="space-y-4" data-id="element-1010" data-mp="1n88uhzlpvuci">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg" data-id="element-1011" data-mp="1s8dc5syd2v4b">
                <div className="flex items-center gap-4" data-id="element-1012" data-mp="1x77vqx45knph">
                  <div className="w-16 h-16 bg-white rounded-lg flex items-center justify-center" data-id="element-1013" data-mp="1x7pwa5xulo37">
                    <PackageIcon className="w-8 h-8 text-gray-400" data-id="element-1014" data-mp="3taw01f22326o" />
                  </div>
                  <div data-id="element-1015" data-mp="3ocukh43u9kzy">
                    <p className="font-medium text-gray-900" data-id="element-1016" data-mp="3o96rq767x2ma">
                      Order #GZ-ABC123
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-1017" data-mp="24bhkjq2h2l9">
                      2 items • PKR 45,999
                    </p>
                    <p className="text-xs text-gray-400" data-id="element-1018" data-mp="fuol89vxdv4s">
                      Placed on Jan 15, 2024
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-1019" data-mp="ptdvphlhsdb0">
                  <span className="px-3 py-1 bg-green-100 text-green-700 text-sm font-medium rounded-full" data-id="element-1020" data-mp="psb8pkraiv0d">
                    Delivered
                  </span>
                </div>
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg" data-id="element-1021" data-mp="2rliv1e5bmcvr">
                <div className="flex items-center gap-4" data-id="element-1022" data-mp="2mn7jmyzdnubf">
                  <div className="w-16 h-16 bg-white rounded-lg flex items-center justify-center" data-id="element-1023" data-mp="1245967rbisp9">
                    <PackageIcon className="w-8 h-8 text-gray-400" data-id="element-1024" data-mp="172oty4u6dyg1" />
                  </div>
                  <div data-id="element-1025" data-mp="sebvn17m83id">
                    <p className="font-medium text-gray-900" data-id="element-1026" data-mp="seu02l4flo1d">
                      Order #GZ-DEF456
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-1027" data-mp="xbkez54i2dl7">1 item • PKR 12,999</p>
                    <p className="text-xs text-gray-400" data-id="element-1028" data-mp="jccd24gycrdb">
                      Placed on Jan 20, 2024
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-1029" data-mp="9fg3dvfbhz76">
                  <span className="px-3 py-1 bg-blue-100 text-blue-700 text-sm font-medium rounded-full" data-id="element-1030" data-mp="9gr4tolaiuv4">
                    In Transit
                  </span>
                </div>
              </div>
            </div>
          </Card>

          {/* Saved addresses */}
          <Card padding="lg" data-id="element-1031" data-mp="28sk63xf42mdn">
            <div className="flex items-center justify-between mb-6" data-id="element-1032" data-mp="28rsawnpfeqnw">
              <h3 className="text-lg font-semibold text-gray-900" data-id="element-1033" data-mp="wj8aocsl1vq4">
                Saved Addresses
              </h3>
              <Button variant="outline" size="sm" data-id="element-1034" data-mp="rl6pnmbljmc0">
                Add New
              </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1035" data-mp="mraxx1lxevpa">
              {user?.addresses.map(address => <div key={address.id} className={`p-4 rounded-lg border-2 ${address.isDefault ? 'border-primary-600 bg-primary-50' : 'border-gray-200'}`} data-id="element-1036" data-mp="htsn15ocm6en">
                  {address.isDefault && <span className="text-xs font-medium text-primary-600 mb-2 block" data-id="element-1037" data-mp="8sl0fkv72u0e">
                      Default
                    </span>}
                  <p className="font-medium text-gray-900" data-id="element-1038" data-mp="3w4aqm8ck7l7">{address.name}</p>
                  <p className="text-sm text-gray-600 mt-1" data-id="element-1039" data-mp="3v2f55ziuqa3k">
                    {address.address}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-1040" data-mp="1y5y89k2in069">
                    {address.city}, {address.postalCode}
                  </p>
                  <p className="text-sm text-gray-500 mt-2" data-id="element-1041" data-mp="20tifr3bj55vu">{address.phone}</p>
                </div>)}
            </div>
          </Card>
        </div>
      </div>
    </div>;
  <div data-id="element-1042" data-mp="25ph10i1ka7s1" />;
}